export default "__VITE_ASSET__8jqoPv1E__"